import * as THREE from "three"
import { debugObject, lightsFolder, scene } from "./Experience"

export class Lights {
  constructor() {
    this.setLights()
    this.setTweaks()
  }

  setLights() {
    const params = {
      pointLight: 1,
      pointLightDist: 0.32,
      pointLightColor: "#c7ff6e",
      hemiLight: 0.594,
      dirLight: 1,
      dirLightColor: "#fff7d1",
    }

    //!Light setup0
    // this.pointLight = new THREE.PointLight(params.pointLightColor, params.pointLight)
    // this.pointLight.position.set(0, 3, params.pointLightDist)
    // scene.add(this.pointLight)

    // const hemiLight = new THREE.HemisphereLight( 0xffffff, 0xffffff, params.hemiLight);
    // hemiLight.color.setHSL( 0.6, 1, 0.6 );
    // hemiLight.groundColor.setHSL( 0.095, 1, 0.75 );
    // hemiLight.position.set( 0, 50, 0 );
    // scene.add( hemiLight );

    // const dirLight = new THREE.DirectionalLight( 0xffffff, params.dirLight);
    // dirLight.color.set(params.dirLightColor);
    // dirLight.position.set( - 1, 1.75, 1 );
    // dirLight.position.multiplyScalar( 30 );
    // scene.add( dirLight );

    //!Light setup1
    this.ambientLight = new THREE.AmbientLight("white", 0.2)
    scene.add(this.ambientLight)

    this.pointLight0 = new THREE.PointLight(debugObject.globalLightColor, 0.6)
    this.pointLight0.position.set(2, 0.8, 2)
    scene.add(this.pointLight0)

    this.pointLight1 = new THREE.PointLight(debugObject.accentLightColor, 0.7)
    this.pointLight1.position.set(-4, 0.8, -1)
    scene.add(this.pointLight1)
  }

  setTweaks() {
    lightsFolder
      .addInput(debugObject, "globalLightColor")
      .on("change", (ev) => {
        this.pointLight0.color = new THREE.Color(ev.value)
      })

    lightsFolder.addInput(this.pointLight0, "intensity", {
      min: 0,
      max: 2,
      label: "Global Light Intensity",
    })

    lightsFolder
      .addInput(debugObject, "accentLightColor")
      .on("change", (ev) => {
        this.pointLight1.color = new THREE.Color(ev.value)
      })

    lightsFolder.addInput(this.pointLight1, "intensity", {
      min: 0,
      max: 2,
      label: "Accent Light Intensity",
    })
  }
}
